<script>
export default {
  props: {
    compact: {
      type: Boolean,
      default: false,
    },
    headerTitle: {
      type: String,
      default: '',
    },
    headerContent: {
      type: String,
      default: '',
    },
    headerContentValue: {
      type: String,
      default: '',
    },
    headerImage: {
      type: String,
      default: '',
    },
  },
};
</script>

<!-- eslint-disable vue/no-unused-refs -->
<!-- Added ref for writing specs -->
<template>
  <div
    class="flex flex-col items-start pb-0"
    :class="compact ? 'px-5 pt-5' : 'px-8 pt-8'"
  >
    <img v-if="headerImage" :src="headerImage" alt="No image" />
    <h2
      data-test-id="modal-header-title"
      :class="
        compact
          ? 'text-sm font-semibold leading-5 text-n-slate-12'
          : 'text-base font-semibold leading-6 text-n-slate-12'
      "
    >
      {{ headerTitle }}
    </h2>
    <p
      v-if="headerContent"
      data-test-id="modal-header-content"
      :class="
        compact
          ? 'mt-1.5 w-full text-xs leading-4 break-words text-n-slate-11'
          : 'mt-2 w-full text-sm leading-5 break-words text-n-slate-11'
      "
    >
      {{ headerContent }}
      <span
        v-if="headerContentValue"
        class="text-sm font-semibold text-n-slate-11"
      >
        {{ headerContentValue }}
      </span>
    </p>
    <slot />
  </div>
</template>
